module.exports = __webpack_public_path__ + "static/media/headerLogo.c6220aa6.png";